import { Http, Headers,Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { AuthRequest } from 'app/models/authrequest';
import { AuthProviderService } from 'app/services/auth.provider.service';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { Token } from '@angular/compiler';


@Injectable()

export class ApiService {

  private url: string;
  private cspUrl: string;
  constructor(private http: Http, private authProvider: AuthProviderService, private envService: EnvironmentsService) {
    this.url = this.authProvider.getApiUrl();
  }

  authenticateToken(authData: AuthRequest) {
    return this.http.post(`${this.url}/tokens`, authData, { withCredentials: true });
  }

  authenticate(code: string, clientId: string, redirectUri: string,) {

    let cspUrl = this.envService.config.espApi + "admin/v1/auth/csp/login";
    let headers = new Headers()
    headers.set('Content-Type', 'application/x-www-form-urlencoded')
    headers.set('Authorization', 'Basic ' + btoa(clientId + ":"))
    let params = {
      "grant_type": "authorization_code",
      "code": code,
      "redirect_uri": redirectUri,
      "code_verifier": this.envService.config.codeVerifier,
      "client_id": clientId,
      "orgId": this.envService.config.orgId
    }
    let body = Object.keys(params)
      .map((key) => { return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]); })
      .join('&');

    return this.http.post(cspUrl,
      body,{ headers: headers, withCredentials: true })
      .map((response: Response) => {
        return response;
      });  

      }

  authorize(token:string){
    let data = {resource: 'configmax-admin', action: 'access'};
    return this.http.post(`${this.envService.config.authApiUrl}`, data, { withCredentials: true });
  }

  refreshToken(token: string) {
    let data = {grant_type: 'refresh_token', refresh_token: token};
    return this.http.post(`${this.url}/tokens`, data, { withCredentials: true });
  }

  login(payload: any) {
    return this.http.put(this.envService.config.espApi + 'admin/v1/auth/login', payload, { withCredentials: true });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts